import React, { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import Reaction from "../../Common/Reaction";
import moment from "moment";
import { KENDO_DATE_FORMAT } from "src/constants";
import { get } from "lodash";
import ReplyThread from "./ReplyThread";
import DisplayReaction from "../../Common/Reaction/DisplayReaction";
import { useVisionComments } from "Hooks/vision/useVisionComments";
import { checkArrayLength } from "src/utils";
import { useFormContext } from "react-hook-form";
import ComposeMsg from "../ComposeMsg";
import ProfileView from "./ProfileView";

const ParentMessageDisplay = ({ parentComment }) => {
  const classes = useStyles();
  const { watch, setValue } = useFormContext();
  const { comments, commentText, reactionLoading, visionCreator, parentMessageId, loading } =
    watch();
  const { reactionComment } = useVisionComments();
  const [reRender, setReRender] = useState(false);
  const likeCount = checkArrayLength(get(parentComment, "usersGivenLike", []));
  const loveCount = checkArrayLength(get(parentComment, "usersGivenLove", []));
  useEffect(() => {
    setReRender(data => !data);
  }, [likeCount, loveCount]);
  const replyComment = messageId => {
    if ([messageId].includes(parentMessageId)) {
      setValue("parentMessageId", "0");
    } else {
      setValue("parentMessageId", messageId);
    }
  };

  return (
    <li>
      <Box display="flex">
        <ProfileView parentComment={parentComment} />
        <Box className={classes.comment} position="relative" width="100%">
          <Box position="absolute" className="msg-reaction">
            <Reaction
              reactionComment={reactionComment}
              visionCreator={visionCreator}
              parentComment={parentComment}
              comments={comments}
              setValue={setValue}
              loading={reactionLoading}
              replyComment={() => replyComment(parentComment.id)}
            />
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" className="font-12">
              {get(parentComment, "comment", "")}
            </Typography>
            <Box className={classes.displayReaction}>
              <DisplayReaction
                key={reRender}
                likeCount={likeCount}
                loveCount={loveCount}
              />
            </Box>
          </Box>
          <Typography variant="body2" className="f-light-gray font-12">
            {get(parentComment, "createdAt")
              ? moment(get(parentComment, "createdAt")).format(
                KENDO_DATE_FORMAT
              )
              : moment().format(KENDO_DATE_FORMAT)}
          </Typography>
        </Box>
      </Box>
      {parentMessageId === parentComment.id ? (
        <Box display="flex" ml={4}>
          <ComposeMsg
            loading={get(loading, "child", false)}
            commentText={parentMessageId != "0" ? commentText : ""}
          />
        </Box>
      ) : null}
      {checkArrayLength(get(parentComment, "commentThread", [])) ? (
        <ReplyThread commentThread={parentComment.commentThread} />
      ) : null}
    </li>
  );
};

export default ParentMessageDisplay;
